import React from 'react'

function FeatureArtwork({ content }) {
  return (
    <section id={'featureArtwork'} className="FeatureArtwork">
      {content.main.map((content, _idx) => (
        <FeatureArtworkItem
          key={`FeatureArtworkItem-${_idx}`}
          content={content}
        />
      ))}
    </section>
  )
}

function FeatureArtworkItem({ content }) {
  return (
    <div className={'FeatureArtwork-item'}>
      <h1>{content.h}</h1>
      <div className={'FeatureArtwork-itemContent'}>
        {content.img}
        <p>{content.p}</p>
      </div>
    </div>
  )
}

export default FeatureArtwork



// WEBPACK FOOTER //
// ./src/Views/Home/FeatureArtwork.js